import React from 'react';

import { type CardProps, isBENCard, isVideoCard } from 'Common/util/ben';

import BENCard from 'Components/Card/Ben';
import VideoCard from 'Components/Card/Ben/Video';
import ListingCard, { ListingCardProps } from 'Components/Card/Listing';
import { PaginationProps } from 'Components/Pagination';

import { Listing, ListItem } from 'Modules/MiniListing/Ben/Ben.styled';
import { NoResults, PaginationWrapper, StyledPagination } from './MediaHub.styled';

export interface Props {
    results: (CardProps & { id: string })[];
    pagination: PaginationProps;
    promo: ListingCardProps;
}

const MediaHub: React.FC<Props> = props => {
    const { results, pagination, promo } = props;

    return (
        <div>
            {results.length > 0 ? (
                <Listing>
                    {results.map((item, index) => (
                        <React.Fragment key={item.id}>
                            <ListItem>
                                {isBENCard(item) && <BENCard {...item} />}
                                {isVideoCard(item) && <VideoCard {...item} />}
                            </ListItem>
                            {results.length === 15 && index === 10 && (
                                <ListItem>
                                    <ListingCard {...promo} />
                                </ListItem>
                            )}
                        </React.Fragment>
                    ))}
                </Listing>
            ) : (
                <NoResults>The filters you’ve selected do not match any results.</NoResults>
            )}
            {results.length > 0 && (
                <PaginationWrapper>
                    <StyledPagination {...pagination} />
                </PaginationWrapper>
            )}
        </div>
    );
};

export default MediaHub;
